export const journeyCheckout = {
  header: {
    backButton: "Back",
    secureCheckout: "Fullscript secure checkout",
    patientInfo: "Patient info",
    billingInformation: "Billing information",
    payment: "Payment",
  },
  availability: {
    title: "First, let's confirm that Journeys is available in your area:",
    emailLabel: "Email address",
    zipCodeLabel: "Zip code",
    locationNote: "Availability based on location",
    continueButton: "Continue",
    errors: {
      emailInvalid: "Please enter a valid email address",
      packagePrefix: "Package:",
      zipCodePrefix: "Zip code:",
      notAvailable: "Journey is not available in your area",
      generalError: "An error occurred while checking availability. Please try again.",
    },
  },
  login: {
    welcomeBack: "Welcome back!",
    accountExists: "It looks like you already have a Fullscript account. Please login below",
    emailLabel: "Email address",
    passwordLabel: "Password",
    continueButton: "Continue",
    backButton: "Back",
    or: "Or",
    errors: {
      twoFactorNotSupported:
        "Two-factor authentication is not currently supported for Journey checkout. Please try a different sign-in method.",
      signInError: "An error occurred during sign-in. Please try again.",
    },
  },
  orderSummary: {
    title: "Order summary",
    journeyWith: "Journey with {{practitionerName}}",
    productName: "Comprehensive Metabolic",
    interpretationTitle: "Interpretation & wellness plan including:",
    features: {
      labMarkers: "{{count}} unique biomarkers",
      chartAccess: "Permanent access to your results",
      detailedInterpretation: "Detailed interpretation of results",
      supplementList: "{{storeDiscount}}% off recommended supplements",
      lifestyleRecommendations: "Nutrition & lifestyle recommendations",
      nextSteps: "Provider-guided next steps",
    },
    subtotal: "Subtotal",
    taxesEstimated: "Taxes (est.)",
    taxesDeferred: "Calculated on next step",
    total: "Total",
    showOrderSummary: "Show order summary",
    hideOrderSummary: "Hide order summary",
  },
  signup: {
    title: "Create your Fullscript account",
    subtitle: "Let's get you signed up to access your Journey",
    firstNameLabel: "First name",
    lastNameLabel: "Last name",
    emailLabel: "Email address",
    passwordLabel: "Password",
    createAccountButton: "Create my account",
    backButton: "Back",
    or: "Or",
    errors: {
      signUpError: "An error occurred during sign-up. Please try again.",
    },
  },
  patientInfo: {
    title: "Patient information",
    firstNameLabel: "First name",
    lastNameLabel: "Last name",
    dateOfBirthLabel: "Date of birth",
    biologicalSexLabel: "Biological sex",
    phoneNumberLabel: "Phone number",
    passwordLabel: "Password",
    requiredForLabTesting: "Required for lab testing",
    continueButton: "Continue",
    journeysAvailable:
      "Journeys is available in your area! Complete your patient profile to get started",
    accountWillBeCreated: "A Fullscript account will be created for",
    accountBenefits:
      "It will keep your orders, health data, and personalized plan accessible in one place.",
    selectPlaceholder: "Select...",
    biologicalSexOptions: {
      male: "Male",
      female: "Female",
    },
    journeysUnavailablePregnantOrLactating:
      "At this time, we are unable to offer Journeys to those who are pregnant or lactating.",
    pregnantOrLactatingLabel: "I am currently pregnant or lactating.",
    errors: {
      signUpError: "An error occurred while creating your account. Please try again.",
      recaptchaError: "reCAPTCHA verification failed. Please try again.",
      genericError: "Something went wrong. Please try again.",
      invalidPhoneNumber: "Please enter a valid phone number",
    },
  },
  waitlist: {
    title: "Journeys are not yet available in your area",
    titleOrderLimit: "Journeys is at full capacity",
    description:
      "Join the waitlist now and we'll notify you when Journeys become available near you.",
    descriptionOrderLimit:
      "This early Journeys offer is already full. Don't worry. Join the waitlist and we'll let you know as soon as the next round opens.",
    emailPlaceholder: "Email address",
    submitButton: "Join Waitlist",
    successToast:
      "You've been added to the waitlist! We'll notify you when Journeys become available near you.",
    errorToast: "An error occurred while adding you to the waitlist. Please try again.",
  },
} as const;
